import { render, staticRenderFns } from "./imageItem.vue?vue&type=template&id=e2601be6&"
import script from "./imageItem.vue?vue&type=script&lang=ts&"
export * from "./imageItem.vue?vue&type=script&lang=ts&"
import style0 from "./imageItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports